import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section, Eyebrow, EmptyState, Skeleton } from "@/components/domain/Bits";
import RaffleCard from "@/components/domain/RaffleCard";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Ticket } from "lucide-react";

export default function Raffles() {
  const [raffles, setRaffles] = useState(null);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/raffles").then((r) => setRaffles(r.data)); }, []);
  const filtered = raffles?.filter((r) => filter === "all" ? true : r.status === filter) || [];

  return (
    <Section className="py-14">
      <Eyebrow><Ticket className="h-3.5 w-3.5" />Catálogo</Eyebrow>
      <h1 className="mt-4 text-4xl font-bold tracking-tight text-slate-900">Sorteos</h1>
      <p className="mt-2 max-w-xl text-slate-600">Explora todos los sorteos y su estado. Cada uno con premio, precio y progreso reales.</p>

      <Tabs value={filter} onValueChange={setFilter} className="mt-8">
        <TabsList data-testid="raffle-filters">
          <TabsTrigger value="all" data-testid="filter-all">Todos</TabsTrigger>
          <TabsTrigger value="active" data-testid="filter-active">Activos</TabsTrigger>
          <TabsTrigger value="scheduled" data-testid="filter-scheduled">Próximos</TabsTrigger>
          <TabsTrigger value="sold_out" data-testid="filter-sold">Agotados</TabsTrigger>
          <TabsTrigger value="finished" data-testid="filter-finished">Finalizados</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="mt-8">
        {raffles === null ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{[0,1,2].map((i) => <Skeleton key={i} className="h-80" />)}</div>
        ) : filtered.length === 0 ? (
          <EmptyState icon={Ticket} title="Sin sorteos en esta categoría" desc="Prueba con otro filtro o vuelve pronto." />
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((r, i) => <RaffleCard key={r.id} raffle={r} index={i} />)}
          </div>
        )}
      </div>
    </Section>
  );
}
